import ApprovalConfigurationDetail from '@/models/ApprovalConfiguration/ApprovalConfigurationDetail';

export default class ApprovalConfigurationDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.approvalConfigurationId  = '';
		this.approvalConfigurationName = '';
		this.approverTypeId  = '';
		this.approverTypeName = '';
		this.approvalStructureId  = '';
		this.approvalStructureName = '';
		this.approverLevel = '';
		this.approverUserNameUserName  = '';
		this.approverUserNameFirstName = '';
		this.storedProcedureName = '';
		this.approvalType = '';
		this.configurationContentMultiple = '';
		this.isSendNotification = false;
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			approvalConfigurationId : '0',
			approvalConfigurationName : '0',
			approverTypeId : '0',
			approverTypeName : '0',
			approvalStructureId : '0',
			approvalStructureName : '0',
			approverLevel : '0',
			approverUserNameUserName : '0',
			approverUserNameFirstName : '0',
			storedProcedureName : '0',
			approvalType : '0',
			configurationContentMultiple : '0',
			isSendNotification : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}